/*
 * @overview: api封装
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-06-28 15:30:09
 */

let domain = "";
export const noticeApi = `/online-release/wallet/v1/getSystemNotice`;
export const serviceApi = `/online-release/wallet/v1/getServerRelease`;

export function initHttp(opts) {
  domain = opts.domain;
}

/**
 * 根据key 请求升级通知
 */
export function getNotice(key) {
  return new Promise(function (resolve, reject) {
    ajax(`${domain}${noticeApi}?systemId=${key}`, "POST", null, function (
      response
    ) {
      resolve(JSON.parse(response));
    });
  });
}

/**
 * 获取后端升级列表
 */
export function getService() {
  return new Promise(function (resolve, reject) {
    ajax(`${domain}${serviceApi}`, "POST", null, function (response) {
      resolve(JSON.parse(response));
    });
  });
}

/**
 * 封装原生ajax
 */
function ajax(url, method, data, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      callback(xhr.responseText);
    }
  };
  xhr.open(method, url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(JSON.stringify(data));
}
